import React, {useMemo} from "react";
import groupBy from "lodash.groupby";
import {FullProduct} from "ts/api/product";

import separateProductsWithApproval from "tools/product/separateProductsWithApproval";
import {IShow} from "@evennt-tech/api-v2-core";
import {CartFlowType} from "../../../../types";
import SupplierProductsBlock from "../SupplierProductsList";

type Props = {
  products: FullProduct[];
  show: IShow;
  cartFlowType: CartFlowType;
};
const ProductBlocks = ({cartFlowType, products, show}: Props) => {
  const {
    productsWithApprovalGroupedBySupplier,
    productsWithoutApprovalGroupedBySupplier,
  } = useMemo(() => {
    const {
      productsWithApproval,
      productsWithoutApproval,
    } = separateProductsWithApproval(products);
    const productsWithApprovalGroupedBySupplier = groupBy(
      productsWithApproval,
      "owner.id"
    );
    const productsWithoutApprovalGroupedBySupplier = groupBy(
      productsWithoutApproval,
      "owner.id"
    );
    return {
      productsWithApprovalGroupedBySupplier,
      productsWithoutApprovalGroupedBySupplier,
    };
  }, [products]);

  return (
    <>
      {Object.values(productsWithoutApprovalGroupedBySupplier).map(
        (products) => (
          <SupplierProductsBlock
            key={products[0].id}
            products={products}
            show={show}
          />
        )
      )}
      {Object.values(productsWithApprovalGroupedBySupplier).map((products) => (
        <SupplierProductsBlock
          showPoNumber={cartFlowType === CartFlowType.created}
          requireApproval
          key={products[0].id}
          products={products}
          show={show}
        />
      ))}
    </>
  );
};

export default ProductBlocks;
